import { CheckCircle2, ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

interface ActionCardProps {
  actions: string[];
}

export function ActionCard({ actions }: ActionCardProps) {
  const [expanded, setExpanded] = useState(false);

  if (actions.length === 0) return null;

  // Clean up action summary text for display
  const cleanAction = (action: string) => {
    if (action.startsWith("{") || action.startsWith("[")) return "Action completed";
    // Capitalise first letter
    const cleaned = action.replace(/^[a-z_]+:\s*/i, "").trim() || action;
    return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  };

  return (
    <div className="mt-2 rounded-lg border border-green-500/30 bg-green-500/5 p-3">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex w-full items-center gap-2 text-left text-sm font-medium text-green-600 dark:text-green-400"
      >
        <CheckCircle2 className="h-4 w-4 flex-shrink-0" />
        <span>
          {actions.length} action{actions.length !== 1 ? "s" : ""} performed
        </span>
        {expanded ? (
          <ChevronUp className="ml-auto h-3 w-3" />
        ) : (
          <ChevronDown className="ml-auto h-3 w-3" />
        )}
      </button>
      {expanded && (
        <ul className="mt-2 space-y-1 pl-6">
          {actions.map((action, i) => (
            <li key={i} className="text-xs text-muted-foreground">
              ✓ {cleanAction(action)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
